export const projectsList = [
  {
    id: 1,
    name: 'Guitar Store',
    imgName: 'react-project',
    githubUrl: 'https://github.com/pedrolampo/proyecto-react',
    demoUrl: 'https://github.com/pedrolampo/proyecto-react',
    paragraph:
      'My first React project. Using Firebase to control stock and adding/removing items, storing data about purchases and users and Firestore authentication for creating accounts and login.',
  },
  {
    id: 2,
    name: "Peter's Notes",
    imgName: 'note-app',
    githubUrl: 'https://github.com/pedrolampo/note-taking-app',
    demoUrl: 'https://peters-notes.vercel.app/',
    paragraph:
      "This started as a simple note taking app, just so I can practice React. But it ended being very useful, both for learning how to document in markdown and for having all those notes on hand. It's made in React and it uses Firebase for storing all the info, aswell as the authenticaton method.",
  },
  {
    id: 15,
    name: 'Steam Redesign',
    imgName: 'steam-redesign',
    githubUrl: 'https://github.com/pedrolampo/steam-redesign',
    demoUrl: 'https://peter-steam-redesign.vercel.app/',
    paragraph:
      "I stumbled across with a video where someone re-designed the complete Steam UI, and I loved it! Huge disclaimer: The design is not mine, all credits go to Juxtopposed (links in the github README). I liked it so much, that I decided to make it real, it's still under development.",
  },
  {
    id: 3,
    name: 'Wordle Clone',
    imgName: 'wordle-clone',
    githubUrl: 'https://github.com/pedrolampo/wordle-clone',
    demoUrl: 'https://pedrolampo.github.io/wordle-clone/',
    paragraph:
      "This is a clone of the famouse game Wordle. I've made it so the game can played in English and in Spanish aswell, and has a light/dark mode switch. Also, it's not daily, you can play as many times as you want.",
  },
  {
    id: 4,
    name: 'Where to watch it?',
    imgName: 'where-to-watch',
    githubUrl: 'https://github.com/pedrolampo/where-to-watch',
    demoUrl: 'https://wheretowatchit.netlify.app/',
    paragraph:
      "Here I wanted to try using multiple API's, utilizing the user's input, searching on two different API's while awaiting one's promise, and posting the result. It searchs movies or tv shows on two DB and returns on which streaming platform you can watch it.",
  },
  {
    id: 5,
    name: 'Código Morsa',
    imgName: 'codigo-morsa',
    githubUrl: 'https://github.com/pedrolampo/codigo-morsa',
    demoUrl: 'https://pedrolampo.github.io/codigo-morsa/',
    paragraph:
      'Just a simple morse code translator, but the catch is that the word "morse" sounds a lot like "morsa", that means \'walrus\' in spanish.',
  },
  {
    id: 6,
    name: 'Text Adventure Game (WIK)',
    imgName: 'text-adventure',
    githubUrl: 'https://github.com/pedrolampo/text-adventure',
    demoUrl: 'https://pedrolampo.github.io/text-adventure/',
    paragraph:
      "This is a long term project, a text adventure game. The game itself it's done, all thats's left is the story, that I'm currently working on. You can check it out if you want to see how it works!",
  },
  {
    id: 7,
    name: 'Budgets App',
    imgName: 'budget-app',
    githubUrl: 'https://github.com/pedrolampo/budget-app',
    demoUrl: 'https://budgetsapp.netlify.app/',
    paragraph:
      'This is a Reactjs project I made just to practice my skills. You can create many budgets and expenses to keep track of them.',
  },
  {
    id: 8,
    name: 'Google Dino Clone',
    imgName: 'dino-clone',
    githubUrl: 'https://github.com/pedrolampo/chrome-dino-game-clone',
    demoUrl: 'https://pedrolampo.github.io/chrome-dino-game-clone/',
    paragraph:
      'Another game clone, this time the famous Google Dino. If you want to play it while having internet, you can give it a try.',
  },
  {
    id: 9,
    name: 'Sumo Fanpage',
    imgName: 'sumo-project',
    githubUrl: 'https://github.com/pedrolampo/proyecto-js',
    demoUrl: 'https://pedrolampo.github.io/proyecto-js/',
    paragraph:
      "This is the first website I made. It's about a rock band from Argentina and has an e-commerce (not fully functional) on it.",
  },
  {
    id: 10,
    name: 'Calculator',
    imgName: 'calculator',
    githubUrl: 'https://github.com/pedrolampo/Calculator',
    demoUrl: 'https://pedrolampo.github.io/Calculator/',
    paragraph:
      'Simple Calculator I made to practice class-based JavaScript programming.',
  },
  {
    id: 11,
    name: 'Pong Game',
    imgName: 'pong-clone',
    githubUrl: 'https://github.com/pedrolampo/pong-clone',
    demoUrl: 'https://pedrolampo.github.io/pong-clone/',
    paragraph:
      'Yet another game clone (yes, I like games). Here you can play the game Pong vs a very simple AI, It keeps track of scores, and background change.',
  },
  {
    id: 12,
    name: 'Palabros',
    imgName: 'palabros',
    githubUrl: 'https://github.com/pedrolampo/palabros',
    demoUrl:
      'https://play.google.com/store/apps/details?id=com.pedrolampo.palabros',
    paragraph:
      "This is my first mobile app. It's made with React Native/Expo. It's another version of the other word game I've done. You can find it in the Play Store!",
  },
  {
    id: 13,
    name: 'Cuberun',
    imgName: 'cuberun',
    githubUrl: 'https://github.com/pedrolampo/cuberun',
    demoUrl: 'https://github.com/pedrolampo/cuberun',
    paragraph:
      "My first project/game in Unity. It's all coded in C#. It's a really simple game, but I'm really proud that I made it all by myself.",
  },
  {
    id: 14,
    name: 'Flappy Birds Clone',
    imgName: 'florpy-borbs',
    githubUrl: 'https://github.com/pedrolampo/florpy-borbs',
    demoUrl: 'https://github.com/pedrolampo/florpy-borbs',
    paragraph:
      'Flappy Birds Clone. Made using Unity and coded in C#. Another cloned game to traing my skills in C# and unity.',
  },
];
